
import { defineComponent, PropType } from 'vue'
import { InformationBlock, Field } from '@/types/api/request'
import { formatDate } from '@/core/utils'

export default defineComponent({
  props: {
    block: {
      type: Object as PropType<InformationBlock>,
      required: true
    }
  },
  setup() {
    function formatValue(field: Field) {
      if(field.valueType === 'DateTime') {
        return formatDate(field.value as string, 'PPP')
      }
      return field.value
    }

    return {
      formatValue
    }
  }
})
